import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { locationsOptions } from '../data-provider/locations';
import type { LocationsParams } from '../models';

export const useGetLocations = (params: LocationsParams) => useQuery(locationsOptions(params));
export const useSuspenseLocations = (params: LocationsParams) => useSuspenseQuery(locationsOptions(params));
